import { render } from "./AffiliateInfo.vue?vue&type=template&id=13c9d1a9&scoped=true"
import script from "./AffiliateInfo.vue?vue&type=script&lang=js"
export * from "./AffiliateInfo.vue?vue&type=script&lang=js"

import "./AffiliateInfo.vue?vue&type=style&index=0&id=13c9d1a9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c9d1a9"]])

export default __exports__